import React from "react";
import { Box, Button, Typography, Paper, Stack } from "@mui/material";
import { PlayArrow as PlayArrowIcon } from "@mui/icons-material";
import { useLogger } from "../../../contexts/LoggerContext";

interface StartGameProps {
 
}

export const StartGame: React.FC<StartGameProps> = () => {
  const { onStartGame } = useLogger();
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      py: 4,
      px: 2,
      textAlign: 'center'
    }}>
      <Paper 
        elevation={2} 
        sx={{ 
          p: 4, 
          maxWidth: 400, 
          width: '100%',
          bgcolor: 'background.paper',
          borderRadius: 2
        }}
      >
        <Stack spacing={2} sx={{ mt: 3 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => onStartGame('KICKOFF')}
            startIcon={<PlayArrowIcon />}
            sx={{ 
              py: 2,
              px: 4,
              fontSize: '1.1rem'
            }}
          >
            Start Game - Kickoff
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => onStartGame('KICKOFF_RETURN')}
            startIcon={<PlayArrowIcon />}
            sx={{ 
              py: 2,
              px: 4,
              fontSize: '1.1rem'
            }}
          >
            Start Game - Receive
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

